import { render, staticRenderFns } from "./NewAcctForNewClient.vue?vue&type=template&id=e648c520&"
import script from "./NewAcctForNewClient.vue?vue&type=script&lang=js&"
export * from "./NewAcctForNewClient.vue?vue&type=script&lang=js&"
import style0 from "./NewAcctForNewClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports